import { useSyncExternalStore } from 'react';

/** Preferência de tela, e não dado: mora no navegador, como a barra recolhida. */
const CHAVE = 'zenda.custos';
const ouvintes = new Set<() => void>();

function ler(): boolean {
  return window.localStorage.getItem(CHAVE) !== 'ocultos';
}

function assinar(fn: () => void): () => void {
  ouvintes.add(fn);
  window.addEventListener('storage', fn);
  return () => {
    ouvintes.delete(fn);
    window.removeEventListener('storage', fn);
  };
}

export function useMostrarCustos(): readonly [boolean, () => void] {
  const mostrar = useSyncExternalStore(assinar, ler);
  const alternar = (): void => {
    window.localStorage.setItem(CHAVE, mostrar ? 'ocultos' : 'visiveis');
    for (const fn of ouvintes) fn();
  };
  return [mostrar, alternar];
}
